import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import type { TypographyProps } from '@mui/material/Typography';

export default function UserCustomers() {
  const appConfig = useSelector(
    (state: { appConfig: { wholesaleEmail?: string; wholesalePhone: string } }) => state.appConfig,
  );

  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      meta.setAttribute('content', 'width=device-width, initial-scale=1.0');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'viewport';
      newMeta.content = 'width=device-width, initial-scale=1.0';
      document.head.appendChild(newMeta);
    }

    return () => {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.remove();
      }
    };
  }, []);

  return (
    <Box sx={{ px: { xs: 2, sm: 3 }, py: { xs: 3, sm: 5 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant={'h7' as TypographyProps['variant']}>
          Customers Service
        </Typography>
      </Box>
      <Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          If you have any questions, please contact us at
          {' '}
          <Link color="inherit" target="_blank" href={`mailto:${appConfig.wholesaleEmail}`}>
            {appConfig.wholesaleEmail}
          </Link>
          {' '}
          , or give us a call at
          {' '}
          <Link color="inherit" target="_blank" href={`tel:${appConfig.wholesalePhone}`}>
            {appConfig.wholesalePhone.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3')}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
